import React, { useEffect, useState, useRef } from 'react'; // Updated import
import { Controller, useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from "react-router-dom";
import Checkbox from '../components/Checkbox';
import arrowBackImg from '../assets/images/arrow_back.svg';
import { updateUser, fetchRoleGroups } from '../commonApi';
import { Button } from 'react-bootstrap';

function Updateuserdetails() {
    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            id: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
        },
    });
    const navigate = useNavigate();
    const location = useLocation();

    const { state: rowData } = location;
    const [formData, setFormData] = useState(() => {
        const storedFormData = localStorage.getItem("formData");
        return storedFormData ? JSON.parse(storedFormData) : {};
    });
    const [isSaveDisabled, setIsSaveDisabled] = useState(false); // New state for save
    const saveButtonRef = useRef(null); // New ref for save button

    useEffect(() => {
        if (rowData) {
            setFormData(rowData);
            localStorage.setItem('formData', JSON.stringify(rowData));
        }
    }, [rowData]);

    useEffect(() => {
        if (formData?.state) {
            setValue("id", formData.state.id || "");
            setValue("firstName", formData.state.firstName || "");
            setValue("lastName", formData.state.lastName || "");
            setValue("email", formData.state.email || "");
            setValue("phone", formData.state.phone || "");
        }
    }, [formData, setValue]);

    const [selectedRoles, setSelectedRoles] = useState(() => {
        return rowData?.state?.roles?.reduce((acc, role) => {
            acc[role] = true;
            return acc;
        }, {});
    });

    useEffect(() => {
        if (formData.state?.roles) {
            const newSelectedRoles = formData?.state?.roles.reduce((acc, role) => {
                acc[role] = true;
                return acc;
            }, {});
            setSelectedRoles(newSelectedRoles);
        }
    }, [formData?.state]);

    const updateForm = async (formData) => {
        if (isSaveDisabled || (saveButtonRef.current && saveButtonRef.current.disabled)) return;

        if (saveButtonRef.current) {
            saveButtonRef.current.disabled = true; // Immediate DOM disable
        }
        setIsSaveDisabled(true); // Update state for UI feedback

        const selectedRoleNames = Object.entries(selectedRoles)
            .filter(([key, value]) => value)
            .map(([key]) => key);

        const dataToSend = {
            ...formData,
            roles: selectedRoleNames,
        };

        try {
            await updateUser(rowData?.state?.id, dataToSend);
            navigate("/users");
            toast.success("User Updated Successfully !!", {
                position: toast?.POSITION?.TOP_RIGHT,
            });
        } catch (error) {
            navigate("/users");
            toast.error("Failed to update user", {
                position: toast?.POSITION?.TOP_RIGHT,
            });
        } finally {
            if (saveButtonRef.current) {
                saveButtonRef.current.disabled = false; // Re-enable button
            }
            setIsSaveDisabled(false); // Reset state
        }
    };

    const [roleGroups, setRoleGroups] = useState([]);

    useEffect(() => {
        fetchRoleGroupsData();
    }, []);

    const fetchRoleGroupsData = async () => {
        try {
            const response = await fetchRoleGroups();
            if (response && response.data) {
                const formattedData = response.data.map(t => ({
                    groupId: t.id,
                    groupName: t.name,
                    roles: t.roles.map(tr => ({
                        roleName: tr
                    }))
                }));
                setRoleGroups(formattedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            toast.error("Failed to load role groups", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const handleCancel = () => {
        navigate("/users");
    };

    const handleCheckboxChange = (roleName) => {
        setSelectedRoles(prev => ({
            ...prev,
            [roleName]: !prev[roleName]
        }));
    };

    const renderCheckboxes = (roles) => {
        return roles.map(role => (
            <div key={role.roleId} style={{ padding: '30px' }}>
                <Checkbox
                    label={role.roleName}
                    checked={!!selectedRoles?.[role?.roleName]}
                    onChange={() => handleCheckboxChange(role?.roleName)}
                />
            </div>
        ));
    };

    return (
        <div className='custom_form_wrapper'>
            <div className="custom_form_header">
                <p className="form_head_title">Update User Details</p>
                <div className="action_cta">
                    <button
                        className="btn page_back_btn"
                        data-bs-target="#delete-model"
                        data-bs-toggle="modal"
                    >
                        <img src={arrowBackImg} alt="Arrow-back" height="16" width="16" />
                        Back
                    </button>
                    <div
                        className="modal fade discard_modal"
                        id="delete-model"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <p className="modal-title" id="staticBackdropLabel">
                                        Discard Changes
                                    </p>
                                </div>
                                <div className="modal-body">
                                    <p className="modal-msg-title">You have unsaved changes on this page.</p>
                                    <p className="modal-msg-desc">Closing without saving will discard your changes.</p>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn_light__red mx-2" data-bs-dismiss="modal" aria-label="Close">
                                        Not Now
                                    </button>
                                    <button className="btn btn_dark__blue" data-bs-dismiss="modal" onClick={handleCancel}>
                                        Discard
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <form onSubmit={handleSubmit(updateForm)} noValidate>
                <div className='custom_form_body_wrapper h-100vh-166px'>
                    <p className='form_section_title'>Basic Details</p>
                    <div className='row'>
                        <div className='col-md-4 col-xxl-3 col-6 mb-4'>
                            <label className="form-label">First Name<span className="required-asterisk" style={{color: "red"}}>*</span></label>
                            <Controller
                                control={control}
                                name="firstName"
                                defaultValue=""
                                render={({ field }) => (
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Please add First Name"
                                        required
                                        {...field}
                                    />
                                )}
                                rules={{ required: "Please enter First Name" }}
                            />
                            <p className="error_msg">{errors?.firstName?.message}</p>
                        </div>
                        <div className='col-md-4 col-xxl-3 col-6 mb-4'>
                            <label className="form-label">Last Name<span className="required-asterisk" style={{color: "red"}}>*</span></label>
                            <Controller
                                control={control}
                                name="lastName"
                                defaultValue=""
                                render={({ field }) => (
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Please add Last Name"
                                        required
                                        {...field}
                                    />
                                )}
                                rules={{ required: "Please enter Last Name" }}
                            />
                            <p className="error_msg">{errors?.lastName?.message}</p>
                        </div>
                        <div className='col-md-4 col-xxl-3 col-6 mb-4'>
                            <label className="form-label">Email<span className="required-asterisk" style={{color: "red"}}>*</span></label>
                            <Controller
                                control={control}
                                name="email"
                                defaultValue=""
                                render={({ field }) => (
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Please add Email"
                                        disabled
                                        {...field}
                                    />
                                )}
                                rules={{ required: "Please enter Email" }}
                            />
                            <p className="error_msg">{errors?.email?.message}</p>
                        </div>
                        <div className='col-md-4 col-xxl-3 col-6 mb-4'>
                            <label className="form-label">Phone<span className="required-asterisk" style={{color: "red"}}>*</span></label>
                            <Controller
                                control={control}
                                name="phone"
                                defaultValue=""
                                render={({ field }) => (
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Please add Phone"
                                        disabled
                                        {...field}
                                    />
                                )}
                                rules={{ required: "Please enter Phone" }}
                            />
                            <p className="error_msg">{errors?.phone?.message}</p>
                        </div>
                    </div>
                    <hr className="border_gray" />
                    <div className="contact_details_wrapper">
                        <p className="form_section_title">Role Details</p>
                        <div className="row">
                            {roleGroups.map(group => (
                                <div key={group.groupId} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <span className='form-label' style={{ margin: '0 20px 0 0', flexShrink: 0, fontWeight: 'bold' }}>{group.groupName}</span>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginLeft: '10px' }}>
                                        {renderCheckboxes(group.roles)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="custom_form_footer_wrapper">
                        <div className="d-flex align-items-center justify-content-end">
                            <button
                                type="button"
                                className="btn light_primary_btn me-3"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </button>
                            <Button
                                type="submit"
                                className="btn primary_btn btn-loader"
                                ref={saveButtonRef}
                                disabled={isSaveDisabled}
                            >
                                {isSaveDisabled ? "Saving..." : "Save"}
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Updateuserdetails;